import React from 'react'
import theGoodPressureEditionImg from '../../images/background_2020.png'

const conferencePostponed = () => (
<section id="interview" className="parallax-section">
	<div className="container">
        <br /><br /><br /><br /><br />
		<div className="row">
			<div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
				<div className="team-wrapper">
						<br /><br />
						<div className="row">
                            <div className="col-md-4">
								<img src={theGoodPressureEditionImg} className="img-responsive" alt="The Good Pressure Edition" />
                            </div>
                         <div className="col-md-8">
							<p>
								<h3>DevExperience 2020 The one with The Good Pressure - technology and meaning, is postponed</h3>
								<p>
								Due to national and international decisions and recommendations concerning public health our event is postponed for the autumn 2020. <br />
								</p>
                            </p>
                           </div>
                        </div>
                        <div className="row">
							<div className="col-md-12">
								<p>
									<br /><br />
                                    Dear guests, partners, and participants at DevExperience 2020, we really need to inform you that our conference scheduled for 26-28 of March has to be postponed to September/October, due to national and international decisions and recommendations concerning public health. <br />
                                    If you already purchased a ticket, you can contact us to receive refunds, or you can maintain your seat for September/October. We sympathize with the whole tech conference organizers out there, and we will keep you posted with news and solutions.
                                    <br /><br /><br /><br />
                                    Dragi invitați, parteneri și participanți la DevExperience 2020, programată să aibă loc între 26-28 Martie, vă anunțăm că, în urma noilor decizii internaționale și naționale cu privire la protecția și siguranța publică, suntem nevoiți să amânăm evenimentul pentru luna septembrie/octombrie. <br />
                                    Cei care și-au achiziționat deja bilete ne pot contacta pentru returnarea investiției sau își pot păstra locurile pentru ediția din septembrie/octombrie. Suntem alături de întreaga comunitate de organizatori de evenimente în #IT și vă ținem la curent cu noutățile din industrie, căutând soluții.
								</p>
							</div>
						</div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default conferencePostponed



// WEBPACK FOOTER //
// ./src/pages/blog/conference-postponed.js